import { useProjectStore } from '@core/store';

import type { SuperHubRouteParams } from '@routes/SuperHub/types';

type ProjectModuleSection = 'graphql' | 'landing';

/**
 * Determines if the specified route section is allowed on the current plan.
 * @example
 * ```ts
 * const isGuidesAllowed = useSectionFeature('docs');
 * ```
 */
export default function useSectionFeature(section: ProjectModuleSection | SuperHubRouteParams['section']) {
  const planFeatures = useProjectStore(s => s.plan.features);
  if (!section) return false;

  /** Hash map indicating whether a route section is allowed access. */
  const planAccessMap = {
    api_definitions: planFeatures.branches,
    changelog: planFeatures.changelogs,
    custom_components: planFeatures.branches,
    discuss: planFeatures.discussions,
    docs: planFeatures.guides,
    graphql: true,
    home: planFeatures.landing_page,
    landing: planFeatures.landing_page,
    page: planFeatures.custom_pages,
    recipes: planFeatures.recipes,
    reference: true,
    reusable_content: planFeatures.branches,
  } as const satisfies Record<typeof section, boolean>;

  return planAccessMap[section];
}
